module.exports = __webpack_public_path__ + "static/media/TooltipIcon.7702778a.png";